<template>
  <okendo-star-rating
    class="c-star-rating"
    :product-id="shopifyProductId"
    @click.native="handleClick"
  />
</template>

<script>
import get from 'lodash/get'
import { OkendoStarRating } from '@okendo/okendo-widgets-vue'
export default {
  components: {
    OkendoStarRating
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    shopifyProductId() {
      return get(this.product, 'pimSyncSourceProductId')
    }
  },
  methods: {
    async handleClick() {
      if (process.client) {
        await this.$nextTick()
        const reviewsElements = document.getElementsByClassName('c-reviews-widget')
        const pageHasReviewsElements = reviewsElements && reviewsElements.length
        if (pageHasReviewsElements) {
          const el = reviewsElements[0]
          if (el) {
            try {
              const navHeight = get(this.$store, 'state.nav.navHeight')
              const offset = (navHeight)
                ? parseInt(navHeight.slice(0, -2), 10)
                : 0
              const pos = el.getBoundingClientRect().top
              window.scrollTo({
                top: pos - offset,
                behavior: 'smooth'
              })
            } catch (err) {
              if (process.env.NODE_ENV !== 'production') {
                console.warn('star-rating', err)
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-star-rating {
  cursor: pointer;
}
</style>
